import { PatientIdentifierResponse } from '@/api/services/common/patient/common-patient.dto'
import { Nullable, StrictNullable } from '@/shared/types/app.types'

export interface RequestTransferModalState {
    id: number
    label: string
    petitioner: string
    department: string
    center: string
    patient: string
    mainPatientIdentifier: Nullable<PatientIdentifierResponse>
    subrequestLabel: StrictNullable<string>
}
export const initialRequestTransferModalState =
    (): RequestTransferModalState => ({
        id: -1,
        center: '',
        department: '',
        label: '',
        mainPatientIdentifier: null,
        patient: '',
        petitioner: '',
        subrequestLabel: null
    })
